import {SelectedValue} from './selectedValue'
/**
 * Class representing an Address
 */
export class Address {
  /**
   * Create a Address.
   * @param {object} options - the address options to construct the address object with
   * @param {String} address1 - the first line of the address
   * @param {String} address2 - the second line of the address
   * @param {String} address3 - the third line of the address
   * @param {String} nameOnDoorBuzzer - the name on the door buzzer
   * @param {String} city - the name of the city
   * @param {String} postcode - the postcode of the place
   * @param {SelectedValue} country - the id of the country
   */
  constructor (options) {
    this.address1 = options.address1
    this.address2 = options.address2
    this.address3 = options.address3
    this.city = options.city
    this.county = options.county
    this.postcode = options.postcode
    this.country = options.country
    this.nameOnDoorBuzzer = options.nameOnDoorBuzzer
  }

  get address1 () {
    return this._address1
  }

  set address1 (value) {
    if (value) this._address1 = String(value)
    else this._address1 = null
  }

  get address2 () {
    return this._address2
  }

  set address2 (value) {
    if (value) this._address2 = String(value)
    else this._address2 = null
  }

  get address3 () {
    return this._address3
  }

  set address3 (value) {
    if (value) this._address3 = String(value)
    else this._address3 = null
  }

  get nameOnDoorBuzzer () {
    return this._nameOnDoorBuzzer
  }

  set nameOnDoorBuzzer (value) {
    if (value) this._nameOnDoorBuzzer = String(value)
    else this._nameOnDoorBuzzer = null
  }

  get city () {
    return this._city
  }

  set city (value) {
    if (value) this._city = String(value)
    else this._city = null
  }

  get county () {
    return this._county
  }

  set county (value) {
    if (value) this._county = String(value)
    else this._county = null
  }

  get postcode () {
    return this._postcode
  }

  set postcode (value) {
    if (value) this._postcode = String(value)
    else this._postcode = null
  }

  get country () {
    return this._country
  }

  set country (value) {
    if (value && value instanceof SelectedValue) {
      this._country = value
    } else if (value) {
      this._country = new SelectedValue(value.id, value.value, value.additionalValue)
    } else {
      this._country = null
    }
  }

  toJSON () {
    return {
      address1: this._address1,
      address2: this._address2,
      address3: this._address3,
      nameOnDoorBuzzer: this._nameOnDoorBuzzer,
      city: this._city,
      county: this._county,
      postcode: this._postcode,
      country: this._country
    }
  }
}
